import { Table, TableBody, TableContainer } from "@mui/material";
import { useContext } from "react";
import Scrollbar from "src/components/Scrollbar";
import useTable, { getComparator } from "src/hooks/useTable";

import Context from "../context";
import CollapseRow from "./CollapseTable/CollapseRow";
import ContextTable from "./contextTable";
import useGetOrderedPositions from "./hooks/useGetOrderedPositions";
import useGetPositionActiveRows from "./hooks/useGetPositionActiveRows";
import useGetPositionRows from "./hooks/useGetPositionRows";
import Row from "./Row";
import TableHeaderPositions from "./TableHeaderPositions";
import TableNotFound from "./TableNotFound";

export default function PositionsTable() {
	const { state } = useContext(Context);
	const isAggregated = state.showType !== "NO_AGREGATED";

	const { demoRows } = useGetPositionRows();
	const { positions } = useGetPositionActiveRows();

	const control = useTable({
		defaultOrderBy: "weight",
		defaultOrder: "desc",
		defaultRowsPerPage: 10,
		defaultDense: true
	});

	const dataFiltered = useGetOrderedPositions({
		inputData: isAggregated ? demoRows : positions,
		comparator: getComparator(control.order, control.orderBy)
	});

	return (
		<ContextTable.Provider value={{ ...control }}>
			<Scrollbar>
				<TableContainer>
					<Table size='small'>
						<TableHeaderPositions count={demoRows.length || 10} />
						<TableBody>
							{dataFiltered.map((row, index) =>
								isAggregated ? <Row {...row} key={index} /> : <CollapseRow {...row} key={index} />
							)}
						</TableBody>
						{dataFiltered.length === 0 && <TableNotFound />}
					</Table>
				</TableContainer>
			</Scrollbar>
		</ContextTable.Provider>
	);
}
